import script from "./WithdrawForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./WithdrawForm.vue?vue&type=script&setup=true&lang=ts"

export default script